export class Modalidade {
  id: number;
  descricao: string;
  status: number;
  padrao: number;
  idTransp?: number;
  nomeTransp: string;
  grupo: string;
  editando: boolean;
  tipoFrete: number;
  idsTransp: number[];
}
